var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 6.4C11.04 6.4 9.6 4.96 9.6 3.2C9.6 1.44 11.04 0 12.8 0C14.56 0 16 1.44 16 3.2C16 4.96 14.56 6.4 12.8 6.4ZM20.8 0H24V0.64C23.84 4.16 22.72 6.88 20.32 8.8C19.52 9.44 18.56 9.92 17.6 10.24V32H14.4V22.4H11.2V32H8V12.96C7.52 13.12 7.2 13.28 7.04 13.44C5.6 14.56 4.816 16 4.8 18.4V19.2H1.6V18.4C1.6 15.2 2.736 12.656 4.976 10.736C6.736 9.296 9.6 8 12.8 8C16 8 17.088 7.264 18.368 6.304C19.968 5.024 20.8 3.2 20.8 0.8V0ZM0 22.4H4.8V32H0V22.4Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsIcon);
export default __webpack_public_path__ + "static/media/stops_icon.99f8c56458691035a71c31ca866b3aae.svg";
export { ForwardRef as ReactComponent };